import { lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
import { RootLayout } from "@/layouts/RootLayout";
import { Landing } from "@/pages/Landing";
import { PageLoader } from "@/components/PageLoader";

// Lazy-load secondary pages to reduce initial bundle
const Products = lazy(() => import("@/pages/Products").then(m => ({ default: m.Products })));
const ProductDetail = lazy(() => import("@/pages/ProductDetail").then(m => ({ default: m.ProductDetail })));
const Story = lazy(() => import("@/pages/Story").then(m => ({ default: m.Story })));
const Connect = lazy(() => import("@/pages/Connect").then(m => ({ default: m.Connect })));
const Download = lazy(() => import("@/pages/Download").then(m => ({ default: m.Download })));
const PrivacyPolicy = lazy(() => import("@/pages/Policy").then(m => ({ default: m.PrivacyPolicy })));
const Terms = lazy(() => import("@/pages/Policy").then(m => ({ default: m.Terms })));
const ProductPolicy = lazy(() => import("@/pages/Policy").then(m => ({ default: m.ProductPolicy })));

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { path: "/", element: <Landing /> },
      { path: "/products", element: <PageLoader><Products /></PageLoader> },
      { path: "/products/:id", element: <PageLoader><ProductDetail /></PageLoader> },
      { path: "/products/:productId/:policyType", element: <PageLoader><ProductPolicy /></PageLoader> },
      { path: "/story", element: <PageLoader><Story /></PageLoader> },
      { path: "/connect", element: <PageLoader><Connect /></PageLoader> },
      { path: "/products/:id/download", element: <PageLoader><Download /></PageLoader> },
      { path: "/privacy-policy", element: <PageLoader><PrivacyPolicy /></PageLoader> },
      { path: "/terms", element: <PageLoader><Terms /></PageLoader> },
    ],
  },
]);
